import Actions      from "../../model/constant/actions"
import ReducerUtils from "../../utils/ReducerUtils"


export const AllLangInventoryFetching = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_ALL_LANG_INVENTORY]           : ()=>true,
  [Actions.RETRIEVE_ALL_LANG_INVENTORY_FOR_ACCOUNT] : ()=>false
})
